import { Button } from "@/components/ui/button";
import { ArrowLeft, Car } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import { commonButtonLabels } from "@/i18n";

interface EmptyStateProps {
  title: string;
  description: string;
  showBackButton?: boolean;
  backUrl?: string;
  icon?: React.ReactNode;
}

const EmptyState = ({ 
  title, 
  description, 
  showBackButton = true, 
  backUrl = "/auctions",
  icon = <Car className="w-12 h-12 text-muted-foreground" />
}: EmptyStateProps) => {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const btnLabels = commonButtonLabels(language);

  const handleBack = () => {
    navigate(backUrl);
  };

  return (
    <div className="min-h-screen bg-transparent relative animate-fade-in">
      <div className="container max-w-6xl py-2 px-4 relative z-10">
        <div className="flex items-center justify-center h-64">
          <div className="text-center">
            <div className="flex justify-center mb-4">
              {icon}
            </div>
            <h2 className="text-xl font-semibold mb-2">{title}</h2>
            <p className="text-muted-foreground mb-6">{description}</p>
            {showBackButton && (
              <Button 
                onClick={handleBack}
                variant="outline"
                className="gap-2"
              >
                <ArrowLeft className="w-4 h-4" />
                {btnLabels.back}
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmptyState; 